import mountainData from './mountainData'

const mountainGame = document.querySelector('.mountain-game')
const mountainGameText = document.querySelector('.mountain-text')

const option1 = document.querySelector('.mountain-option-1')
const option2 = document.querySelector('.mountain-option-2')
const option3 = document.querySelector('.mountain-option-3')

let OnComplete = null
let currentStep = 0

const initMountain = (onComplete) => {
  OnComplete = onComplete
  mountainGame.classList.remove('hidden')
  nextStep()
}

const showSuccess = () => {
  if (currentStep < mountainData.dialog.length) {
    mountainGameText.innerHTML = 'Well Done!'
  } else {
    mountainGameText.innerHTML = 'Well Done! Now you can pass this mountains!'
  }
  option1.innerHTML = 'continue...'
  option1.onclick = nextStep

  if (!option2.classList.contains('hidden')) option2.classList.add('hidden') 
  if (!option3.classList.contains('hidden')) option3.classList.add('hidden') 
}

const showFailure = () => {
  mountainGameText.innerHTML = 'Sorry, try again.'
  option1.innerHTML = 'continue...'
  option1.onclick = nextStep

  currentStep--

  if (!option2.classList.contains('hidden')) option2.classList.add('hidden') 
  if (!option3.classList.contains('hidden')) option3.classList.add('hidden') 
}


const nextStep = () => {
  if (currentStep < mountainData.dialog.length){
    const current = mountainData.dialog[currentStep]
    mountainGameText.innerHTML = current.text
    if (current.type === 'statement') {
      option1.innerHTML = 'continue...'
      option1.onclick = nextStep

      if (!option2.classList.contains('hidden')) option2.classList.add('hidden') 
      if (!option3.classList.contains('hidden')) option3.classList.add('hidden') 
    }

    if (current.type === 'question') {
      if (option2.classList.contains('hidden')) option2.classList.remove('hidden') 
      if (option3.classList.contains('hidden')) option3.classList.remove('hidden')

      option1.innerHTML = current.options[0]
      option2.innerHTML = current.options[1]
      option3.innerHTML = current.options[2]

      option1.onclick = () => {
        if(current.right === 0) {
          showSuccess()
        } else {
          showFailure()
        }
      }

      option2.onclick = () => {
        if(current.right === 1) {
          showSuccess()
        } else {
          showFailure()
        }
      }

      option3.onclick = () => {
        if(current.right === 2) {
          showSuccess()
        } else {
          showFailure()
        }
      }
    }
    
    currentStep++
  } else {
    mountainGame.classList.add('hidden')
    OnComplete()
  }
}

export { initMountain }